import type { Core } from 'chessboard/core/config/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import type { RawKeyedArrow } from 'chessboard/plugins/arrows/config/types';
import { ArrowType } from 'chessboard/plugins/arrows/config/types';
import { createKeyedArrow } from '../model/create-keyed-arrow';

/**
 * add arrows when initializing plugin
 */
export function init(context: Core.Context) {
  const { api, options, renderer } = context;
  if (!api.markings) {
    return;
  }

  const markingsApi = <Markings.API>api.markings;

  const currentRawArrows = options.allowMarkings
    ? <RawKeyedArrow[]>markingsApi.getAllWhere({ types: [ArrowType] })
    : [];
  const currentArrows = currentRawArrows.map((rawArrow) => createKeyedArrow({ rawArrow, options }));

  renderer?.addArrows(currentArrows, context);
}
